import { useDataModel } from "@thd-nucleus/data-sources";
import { TPaintOrderHistoryResponse } from "../types/api";

type TPaintOrderHistoryDataModalResponse = {
  data: TPaintOrderHistoryResponse;
  loading: boolean;
  error: boolean;
  refetch: () => void;
};

const usePaintOrderHistory = (userId: string, customerAccountId: string, tmxProfileId: string) => {
  const isSsr = typeof window === "undefined";

  const headers = {
    tmxProfileId: tmxProfileId || (!isSsr && window?.THD_ACCOUNT_LIB?.TMX?.getTMXsessionId()) || "",
    channelId: "1",
  };

  const request = {
    userId: userId || "",
    customerAccountId: customerAccountId ?? ((!isSsr && window.THDCustomer?.default.svocID) || ""),
    pageSize: 24,
    pageNumber: 1,
    filterKey: "",
    filterValue: "",
    sortBy: "",
    sortOrder: "",
    storeNumber: 1234,
  };

  const { data, loading, error, refetch }: TPaintOrderHistoryDataModalResponse = useDataModel(
    "paintOrderHistory",
    {
      variables: { headers, userId, request },
      ssr: false,
      context: { withAuth: true },
      skip: !userId,
    },
  );

  return {
    data,
    loading,
    error,
    refetch,
  };
};

export default usePaintOrderHistory;
